<template>
  <el-aside width="352px" class="image-info">
    <el-divider color="brand-light" vertical />
    <div class="main-image-info">
      <div class="header-image-info">
        <div class="aside-label">Tags</div>
      </div>
      <el-divider color="brand-light" />
      <el-table
        ref="table"
        :data="images"
        :show-header="false"
        row-key="index"
        border-bottom
        :highlight-current-row="true"
        :virtual-render-limit="Infinity"
        height="fit-scrollable"
        @row-click="handleCurrentChange"
      >
        <el-table-column>
          <template #default="scope">
            <div class="tags-wrapper">
              <div class="tags-text">
                {{ scope.$index + 1 }} # Car Number:
                {{
                  scope.row.tags && scope.row.tags.length
                    ? scope.row.tags[0].car_number
                    : "N/A"
                }}
              </div>
              <div class="tags-btns">
                <el-dropdown placement="bottom-end">
                  <el-button
                    type="icon"
                    :disabled="
                      selectedItem &&
                      selectedItem !==
                        (scope.row.tags &&
                          scope.row.tags.length &&
                          scope.row.tags[0].car_number)
                    "
                  >
                    <el-icon name="i-settings-d-o--16" color="brand-primary" />
                  </el-button>
                  <template #dropdown>
                    <el-dropdown-menu
                      :max-height="Infinity"
                      class="dropdown-menu-example-fixed-width"
                    >
                      <el-dropdown-item
                        ><div>
                          <div>Contrast:</div>
                          <el-input
                            style="width: 200px"
                            type="range"
                            size="small"
                            :max="2"
                            :min="0.1"
                            :step="0.1"
                            v-model="scope.row.filters.contrast"
                            @change="reDrawImg"
                          /></div
                      ></el-dropdown-item>
                      <el-dropdown-item
                        ><div>
                          <div>Brightness:</div>
                          <el-input
                            style="width: 200px"
                            type="range"
                            size="small"
                            :max="2"
                            :min="0.1"
                            :step="0.1"
                            v-model="scope.row.filters.brightness"
                            @change="reDrawImg"
                          /></div
                      ></el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-aside>
</template>

<script>
export default {
  name: "CompareInfo",
  props: {
    images: {
      type: Array,
      required: true,
    },
    selectedItem: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isShowEditTagsDialog: false,
      selectedTags: {},
      selectedTagsCarIndex: -1,
      test: 1,
    };
  },
  methods: {
    reDrawImg() {
      this.$emit("reDrawImg");
    },
    handleCurrentChange(el) {
      this.$emit("change", el.index);
    },
  },
  watch: {
    // selectedCar(value) {
    //   if (this.$refs.table) {
    //     this.$refs.table.setCurrentRow(value);
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
.header-image-info {
  padding: 10px;
}
.tags-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.image-info {
  display: flex;
  .main-image-info {
    flex-grow: 1;
  }
}
</style>
